module.exports = __webpack_public_path__ + "img/powers.0dcb09a8.png";